<template>
  <form @submit.prevent>

    <vs-input
      v-validate="'required|min:2|max:20|alpha'"
      data-vv-validate-on="blur"
      name="first_name"
      label="Имя"
      v-model="first_name"
      :danger="errors.has('first_name')"
      :danger-text="errors.first('first_name')"
    />

    <vs-input
      v-validate="'required|email'"
      data-vv-validate-on="blur"
      name="email"
      type="email"
      label="Почта"
      v-model="email"
      :danger="errors.has('email')"
      :danger-text="errors.first('email')"
    />

    <div class="mt-6">
      <vs-checkbox v-model="isTermsConditionAccepted">
        Я принимаю условия
      </vs-checkbox>
      <span
        @click="openTerms"
        id="accept-link"
      >
        лицензионного договора
      </span>
    </div>

    <vs-button
      type="filled"
      class="mt-6"
      button="submit"
      @click="registerEmployee"
      :disabled="!validateForm"
    >
      Зарегистрироваться
    </vs-button>

  </form>
</template>

<script>
import {
  REGISTER_EMPLOYEE_BY_INVITATION
} from '@/store/action.types'

export default {
  data() {
    return {
      first_name: '',
      email: '',
      isTermsConditionAccepted: false
    }
  },
  computed: {
    validateForm() {
      return (!this.errors.any() && this.isTermsConditionAccepted === true)
    }
  },
  methods: {
    registerEmployee() {
      if (!this.validateForm) return false
      this.$vs.loading()

      const payload = {
        token: this.$route.params.token,
        first_name: this.first_name,
        email: this.email
      }

      this.$store.dispatch(REGISTER_EMPLOYEE_BY_INVITATION, payload).then(() => {
        this.$vs.loading.close()
        this.$vs.notify({
          position: 'top-right',
          title: 'Успешно',
          text: 'Вам отравлено приглашение на указанную электронную почту',
          iconPack: 'feather',
          icon: 'icon-check',
          color: 'success'
        })
      }).catch(({ response }) => {
        this.$vs.loading.close()
        this.$vs.notify({
          position: 'top-right',
          title: 'Не удалось зарегистрироваться',
          text: response.data.error
        })
      })
    },
    openTerms() {
      window.open('https://kontur.ru/lp/market-tips/offers', '_blank')
    }
  }
}
</script>
